package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.funcionarios.Cpf
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.data.os.OrdemServicoDados
import br.com.htms.inspeccaocampo.data.os.PgrCargoOpcao
import br.com.htms.inspeccaocampo.data.os.PgrCatalog
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.AppTab
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.DateInputMask
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults

@Composable
fun SharedOrdemServicoScreen(controller: AppController, embutido: Boolean = false) {
    val gerando by controller.gerandoOrdemServico.collectAsState()
    val versaoDocs by controller.documentosVersao.collectAsState()
    val funcionarioInicial by controller.osFuncionarioInicial.collectAsState()
    val hoje = remember { formatDateBr(currentTimeMillis()).substringBefore(' ') }

    var funcionarios by remember { mutableStateOf<List<Funcionario>>(emptyList()) }
    var buscaFuncionario by remember { mutableStateOf("") }
    var funcionario by remember { mutableStateOf<Funcionario?>(null) }

    var nome by remember { mutableStateOf("") }
    var cpf by remember { mutableStateOf("") }
    var admissao by remember { mutableStateOf("") }
    var selecionado by remember { mutableStateOf<PgrCargoOpcao?>(null) }
    var descricao by remember { mutableStateOf("") }
    var epis by remember { mutableStateOf("") }
    var empresa by remember { mutableStateOf("HTMS ENERGIA") }
    var local by remember { mutableStateOf("Curitiba-PR") }
    var dataEmissao by remember { mutableStateOf(hoje) }
    var tentouGerar by remember { mutableStateOf(false) }

    val blocos = remember(selecionado) { selecionado?.let { PgrCatalog.montarBlocos(it) }.orEmpty() }

    fun selecionarCargo(op: PgrCargoOpcao?) {
        selecionado = op
        descricao = op?.cargo?.descricao.orEmpty()
        epis = op?.let { PgrCatalog.episSugeridos(it).joinToString("\n") }.orEmpty()
    }

    fun aplicarFuncionario(f: Funcionario) {
        funcionario = f
        buscaFuncionario = ""
        nome = f.nome
        cpf = f.cpf
        admissao = f.admissao
        cargoDoFuncionario(f)?.let { selecionarCargo(it) }
    }

    LaunchedEffect(versaoDocs) {
        FuncionariosApi.listar().onSuccess { lista ->
            funcionarios = lista
            val atual = funcionario
            if (atual != null) funcionario = lista.firstOrNull { it.id == atual.id } ?: atual
            if (atual == null && Cpf.valido(cpf)) {
                lista.firstOrNull { it.cpf == Cpf.digitos(cpf) }?.let { funcionario = it }
            }
        }
    }
    LaunchedEffect(funcionarioInicial) {
        funcionarioInicial?.let {
            aplicarFuncionario(it)
            controller.consumirOsFuncionarioInicial()
        }
    }

    val nomeOk = nome.isNotBlank()
    val cpfOk = cpf.isBlank() || Cpf.valido(cpf)
    val admissaoOk = DateInputMask.isCompleteValid(admissao, DateFieldKind.DATE)
    val dataOk = DateInputMask.isCompleteValid(dataEmissao, DateFieldKind.DATE)
    val podeGerar = nomeOk && cpfOk && admissaoOk && dataOk && selecionado != null && !gerando

    DocumentosModulo(controller, AppTab.ORDEM_SERVICO, "Ordem de Serviço (OS)", embutido = embutido) {
        CartaoSecao(
            titulo = "Preenchimento da OS",
            subtitulo = "Versão de TESTE para validar o processo — não é documento oficial. " +
                "Riscos e descrições vêm do ${PgrCatalog.fonte}, que ainda será atualizado."
        ) {
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        val func = funcionario
        if (func == null) {
            AppOutlinedTextField(
                value = buscaFuncionario,
                onValueChange = { buscaFuncionario = it },
                label = { Text("Funcionário cadastrado (buscar por nome, CPF ou matrícula)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            if (buscaFuncionario.isNotBlank()) {
                val achados = filtrarFuncionarios(funcionarios, buscaFuncionario).take(8)
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
                ) {
                    if (achados.isEmpty()) {
                        Text(
                            "Nenhum cadastro encontrado — preencha os dados abaixo; o funcionário será cadastrado ao gerar a OS.",
                            modifier = Modifier.padding(12.dp),
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                    achados.forEachIndexed { i, f ->
                        if (i > 0) HorizontalDivider()
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable { aplicarFuncionario(f) }
                                .padding(horizontal = 12.dp, vertical = 8.dp)
                        ) {
                            Text(f.nomeComVinculo, fontWeight = FontWeight.SemiBold)
                            Text(
                                "CPF ${f.cpfFormatado}" + (if (f.cargoNome.isNotBlank()) " • ${f.cargoNome}" else ""),
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                    }
                }
            }
        } else {
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.secondaryContainer)
            ) {
                Row(Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f)) {
                        Text("Funcionário cadastrado", style = MaterialTheme.typography.labelMedium)
                        Text(func.nomeComVinculo, fontWeight = FontWeight.Bold)
                        Text(
                            "CPF ${func.cpfFormatado} • ${func.totalDocumentos} documento(s)",
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                    TextButton(onClick = {
                        funcionario = null
                        nome = ""
                        cpf = ""
                        admissao = ""
                        selecionarCargo(null)
                    }) { Text("Trocar") }
                }
            }
        }

        AppOutlinedTextField(
            value = nome,
            onValueChange = { nome = it },
            label = { Text("Nome do funcionário") },
            singleLine = true,
            isError = tentouGerar && !nomeOk,
            modifier = Modifier.fillMaxWidth(),
            colors = FormFieldDefaults.textFieldColors()
        )
        CpfTextField(value = cpf, onValueChange = { cpf = it }, isError = !cpfOk && (Cpf.digitos(cpf).length == 11 || tentouGerar))
        if (cpf.isBlank()) {
            Text(
                "Informe o CPF para salvar a OS no cadastro do funcionário.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
        AppDateTextField(
            value = admissao,
            onValueChange = { admissao = it },
            label = "Data de admissão",
            isError = tentouGerar && !admissaoOk
        )

        CargoPgrPicker(
            selecionado = selecionado,
            onSelecionar = { selecionarCargo(it) },
            isError = tentouGerar && selecionado == null
        )
        if (selecionado != null) {
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
            ) {
                Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text("Riscos puxados do PGR", fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodyMedium)
                    blocos.forEach { b ->
                        Text(
                            "${b.categoria.rotulo}: " + b.itens.joinToString("; ") { "${it.numero}. ${it.risco}" },
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
            AppOutlinedTextField(
                value = descricao,
                onValueChange = { descricao = it },
                label = { Text("Descrição da função / atividades habituais") },
                minLines = 3,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            AppOutlinedTextField(
                value = epis,
                onValueChange = { epis = it },
                label = { Text("EPI/EPC recomendados (um por linha)") },
                minLines = 4,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
        }

        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
            AppOutlinedTextField(
                value = empresa,
                onValueChange = { empresa = it },
                label = { Text("Empresa") },
                singleLine = true,
                modifier = Modifier.weight(1f),
                colors = FormFieldDefaults.textFieldColors()
            )
            AppOutlinedTextField(
                value = local,
                onValueChange = { local = it },
                label = { Text("Local") },
                singleLine = true,
                modifier = Modifier.weight(1f),
                colors = FormFieldDefaults.textFieldColors()
            )
        }
        AppDateTextField(
            value = dataEmissao,
            onValueChange = { dataEmissao = it },
            label = "Data da OS",
            isError = !dataOk
        )

        if (tentouGerar && !podeGerar && !gerando) {
            Text(
                "Preencha nome, CPF válido (ou deixe em branco), data de admissão e escolha o cargo na lista.",
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall
            )
        }

        PortalButton(
            onClick = {
                tentouGerar = true
                val op = selecionado ?: return@PortalButton
                if (!podeGerar) return@PortalButton
                controller.gerarOrdemServicoPdf(
                    OrdemServicoDados(
                        nome = nome.trim(),
                        funcao = op.cargo.nome,
                        setorGhe = op.setorGhe,
                        empresa = empresa.trim().ifBlank { "HTMS ENERGIA" },
                        admissao = admissao,
                        blocos = blocos,
                        descricaoFuncao = descricao.trim(),
                        epis = epis.lines().map { it.trim() }.filter { it.isNotEmpty() },
                        localData = "${local.trim().ifBlank { "Curitiba-PR" }}, $dataEmissao"
                    ),
                    cpf = cpf,
                    cargoId = op.id
                )
            },
            enabled = !gerando,
            modifier = Modifier.fillMaxWidth()
        ) {
            if (gerando) {
                CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp)
                Text("  Gerando PDF...")
            } else {
                Text(if (Cpf.valido(cpf)) "Gerar PDF e salvar no cadastro" else "Gerar PDF da Ordem de Serviço")
            }
        }
        }
        }

        funcionario?.let { FuncionarioDocumentosPanel(controller, it) }
    }
}
